/**
 * Navigation — mobile drawer toggle + dropdown keyboard support.
 * No ES module syntax — this file is concatenated into one bundle by Gulp.
 */
function initNavigation() {
    var menuBtn  = document.getElementById('menuOpen');
    var drawer   = document.getElementById('mm-drawer');
    var overlay  = document.getElementById('mmOverlay');
    var closeBtn = document.getElementById('mmClose');

    if ( ! menuBtn || ! drawer ) return;

    function openMenu() {
        drawer.classList.add('open');
        if ( overlay ) overlay.classList.add('on');
        menuBtn.setAttribute('aria-expanded', 'true');
        drawer.setAttribute('aria-hidden', 'false');
        document.documentElement.style.overflow = 'hidden';
        var first = drawer.querySelector('a, button, input');
        if ( first ) first.focus();
    }

    function closeMenu() {
        drawer.classList.remove('open');
        if ( overlay ) overlay.classList.remove('on');
        menuBtn.setAttribute('aria-expanded', 'false');
        drawer.setAttribute('aria-hidden', 'true');
        document.documentElement.style.overflow = '';
        menuBtn.focus();
    }

    menuBtn.addEventListener('click', openMenu);
    if ( closeBtn ) closeBtn.addEventListener('click', closeMenu);
    if ( overlay )  overlay.addEventListener('click', closeMenu);

    drawer.querySelectorAll('a.mm-link').forEach(function(a) {
        a.addEventListener('click', closeMenu);
    });

    document.addEventListener('keydown', function(e) {
        if ( e.key === 'Escape' && drawer.classList.contains('open') ) closeMenu();
    });
}
